import { ViewProps, View } from '@react-pdf/renderer';
import { PropsWithChildren } from 'react';

export function PDFCard(props: PropsWithChildren<ViewProps>) {
  return (
    <View
      {...props}
      style={{
        ...{
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: '#f0f0f0',
          borderRadius: 8,
          padding: 10
        },
        ...props.style
      }}
    />
  );
}
